import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import {
  API_URL,
  API_BASE,
  FILE_STORAGE
} from '../../../constants'

// Actions
import {
  createOrderEstimation,
  uploadMultipleFiles,
  uploadImageMarkings,
  getRejectedEvaluations,
  getOrderFiles,
  DeleteExifData
} from '../../../actions/orders'

// import styles
import './index.scss'

// Utils
import { hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

// import components
import Dropzone from '../../components/Dropzone'
import Modal from '../../components/Modal'
import CircleImage from '../../components/CircleImage'
import Gallery from '../../components/Gallery'

import Portal from '../../components/Portal'
import Confirm from '../../components/Confirm'
import Evaluation from '../../components/Evaluation'

// Elements
import Textarea from '../../elements/textarea'
import Label from '../../elements/label'
import Check from '../../elements/check'
import RemoveButton from '../../elements/removeButton'
import Divider from '../../elements/divider'

import { ModalIcons } from '../../elements/icons'

class CreateEstimationModal extends Component {

  constructor (props) {
    super(props)
    this.state = this.resetState(props)
    this.createEstimation = this.createEstimation.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.submitImage = this.submitImage.bind(this)

    this.onDrop = this.onDrop.bind(this)
    this.onDropAccepted = this.onDropAccepted.bind(this)
    this.onDropRejected = this.onDropRejected.bind(this)
    this.onClose = this.onClose.bind(this)
  }

  componentDidMount () {
    this.setState(this.resetState(this.props))
    let { images } = this.state
    let id = this.props.id
    if (id === undefined) id = this.props.orderId

    this.props.getOrderFiles(id, 1).then((res) => {
      res.data.forEach(function (element) {
        images.push({
          imagePath: FILE_STORAGE + element.FileURL,
          thumbPath: FILE_STORAGE + element.ThumbURL,
          OrderFileID: element.OrderFileID
        })
      }, this)
      this.setState({
        images: images
      })
    })
  }

  t (val) {
    if (typeof translation !== 'undefined') {
      return translation(val)
    }
    return this.props.t(val)
  }

  resetState (setState) {
    let newState = {
      confirm: false,
      isLoading: false,
      tabView: 'step1',
      images: [],
      files: [],
      upload: {
        shouldCapture: true,
        errors: []
      },
      selectedImages: {},
      activeImage: {},
      orderId: this.props.orderId !== undefined ? this.props.orderId : -1,
      rejections: [],
      overflowHidden: false,
      Estimation_comment: ''
    }
    return newState
  }

  componentWillReceiveProps (nextProps) {
    // with "mapStateToProps" on newWorkCard having state.common, is hitting componentWillReceiveProps at every click
    // this.setState(this.resetState(nextProps))
  }
  createEstimation (e) {
    e.preventDefault()
    this.setState({ isLoading: true })

    const createEstimation = (files) => {
      if (files === undefined || files.length === 0) {
        window.toastr.error(translation('13014'), translation('216'))
        this.setState({
          isLoading: false
        })
        return null
      }
      let returnOrder = false
      if (this.props.returnOrder !== undefined && this.props.returnOrder) {
        returnOrder = true
      }
      let data = {
        OrderId: this.state.orderId > 0 ? this.state.orderId : this.props.id,
        Case: {
          Comment: this.state.Estimation_comment
        },
        ImageTypes: files,
        ReturnOrder: returnOrder
      }
      this.props.createOrderEstimation(data).then((res) => {
        // console.log('CreateEstimationModal props', this.props)
        if (this.props.onSave !== undefined) {
          this.props.onSave(res.data)
        }

        // if (this.props.onClose !== undefined) {
        //   this.props.onClose()
        // }
        this.props.onClose()
        // Toastr
        // window.toastr.success(translation('2235'), translation('13424'))
        // Redirect
        // let id = this.state.orderId > 0 ? this.state.orderId : this.props.id
        // this.props.router.push('/orders/' + id)
      }, () => {
        this.setErrors({
          isLoading: false
        })
        // Toastr
        window.toastr.error(translation('2236'), translation('216'))
      })
    }

    let finishedFiles = []
    let inputs = document.getElementsByTagName('input')
    for (let i = 0; i < inputs.length; i++) {
      if (inputs[i].name === 'checkbox_image' && inputs[i].checked === true) {
        finishedFiles.push({
          OrderFileId: inputs[i].id
        })
      }
    }
    if (finishedFiles === 0 && this.state.files.length === 0) {
      createEstimation(finishedFiles)
    } else {
      let files = [...this.state.images].concat(this.state.files)
      let id = this.state.orderId > 0 ? this.state.orderId : this.props.id
      if (id === undefined) id = this.props.orderId
      this.props.uploadMultipleFiles(files, id).then((fileResponse) => {
        let uploadedFiles = fileResponse.data
        let imageMarkings = []
        uploadedFiles.map((val, index) => {
          finishedFiles.push({
            OrderFileID: val.OrderFileID,
            ImageType: 2
          })
          if (val.IsImage) {
            let markings = []
            if (this.state.images[index] !== undefined && this.state.images[index].circles !== undefined) {
              this.state.images[index].circles.map((circle, circleIdx) => {
                markings.push({
                  PositionX: circle.left,
                  PositionY: circle.top,
                  Scale: parseFloat(circle.scale.toFixed(2)),
                  Size: 50
                })
              })
            }
            if (markings.length !== 0) {
              imageMarkings.push({
                ImageSize: this.state.images[index].ImageSize,
                OrderFileID: val.OrderFileID,
                Markings: markings
              })
            } else {
              // console.log('add to files')
              finishedFiles.push({
                OrderFileID: val.OrderFileID,
                ImageType: -1
              })
            }
          }
        })
        if (imageMarkings.length !== 0) {
          this.props.uploadImageMarkings(imageMarkings)
        }
        createEstimation(finishedFiles)
      }, () => {
        this.setErrors({
          isLoading: false
        })
        // Toastr
        window.toastr.error(translation('13440'), translation('216'))
      })
    }
  }

  onInputChange (e) {
    if (e.target.name === 'Estimation') {
      if (!e.target.checked) {
        e.target.value = '0'
      }
    }
    this.setState({ [e.target.name]: e.target.value })
  }
  renderStep1 () {
    let { errors } = this.state.upload
    // Render estimation comment
    const renderEstimationComment = () => {
      let comment = this.state.Estimation_comment
      return (
        <Textarea name='Estimation_comment' onChange={this.onInputChange} value={comment} labelText={translation('13364')} />
      )
    }
    const setEstimationComment = (comment) => {
      this.setState({
        Estimation_comment: comment
      })
    }
    // Render errors
    const renderError = (error, index) => {
      return <p key={index}>{error}</p>
    }
    // Render
    return (
      <div>
        <div className='clearfix'>
          {this.props.topMessage !== undefined && this.props.topMessage.length !== 0 && <div className='alert alert-danger'>{this.props.topMessage.map(renderError)}</div>}
          {errors.length !== 0 && <div className='alert alert-danger'>{errors.map(renderError)}</div>}
          <Evaluation orderId={this.props.id} noParts noCompleted setEstimationComment={setEstimationComment.bind(this)} />
          <Divider noLine />
          <Label>{translation('13719')}</Label>
          <Divider noLine />

          <Dropzone
            onDrop={this.onDrop}
            onDropAccepted={this.onDropAccepted}
            onDropRejected={this.onDropRejected}
            includeCircles>
            <p>{translation('13397')}</p>
          </Dropzone>
          {this.renderFiles()}
          {this.renderImages()}
        </div>
        {renderEstimationComment()}
      </div>
    )
  }

  onDrop () {
    this.setState({ upload: { ...this.state.upload, errors: [] } })
  }

  onDropAccepted (files) {
    let documents = [...this.state.files]
    let images = this.state.images
    let addedImages = []

    // let id = this.state.orderId > 0 ? this.state.orderId : this.props.id
    // if (id === undefined) id = this.props.orderId
    // this.props.uploadMultipleFiles(files, id).then((fileResponse) => {
    //   let uploadedFiles = fileResponse.data
    //   let imageMarkings = []
    //   uploadedFiles.map((val, index) => {
    //     finishedFiles.push({
    //       OrderFileID: val.OrderFileID,
    //       ImageType: 2
    //     })
    //     if (val.IsImage) {
    //       let markings = []
    //       if (this.state.images[index] !== undefined && this.state.images[index].circles !== undefined) {
    //         this.state.images[index].circles.map((circle, circleIdx) => {
    //           markings.push({
    //             PositionX: circle.left,
    //             PositionY: circle.top,
    //             Scale: parseFloat(circle.scale.toFixed(2)),
    //             Size: 50
    //           })
    //         })
    //       }
    //       if (markings.length !== 0) {
    //         imageMarkings.push({
    //           ImageSize: this.state.images[index].ImageSize,
    //           OrderFileID: val.OrderFileID,
    //           Markings: markings
    //         })
    //       }
    //     }
    //   })
    //   if (imageMarkings.length !== 0) {
    //     this.props.uploadImageMarkings(imageMarkings)
    //   }
    // }

    files.map((val) => {
      if (typeof val.file === 'undefined') {
        documents.push(val)
      } else {
        addedImages.push(val)
      }
    })

    images.map((val) => {
      if (typeof val.ImageSize === 'undefined') {
        val.ImageSize = {
          Width: 0,
          Height: 0
        }
      }
    })
    this.props.DeleteExifData(addedImages).then((res) => {
      var k = images.length
      for (var i = 0; i < addedImages.length; i++) {
        if (typeof addedImages[i].ImageSize === 'undefined') {
          // var image = new Image()
          // image.src = files[0].imageUrl
          // image.onLoad((e) => {
          //   console.log('image size', image.width, image.height)
          // })
          addedImages[i].ImageSize = {
            Width: 0,
            Height: 0
          }
        }
        images.push(addedImages[i])
        images[k + i].imageUrl = res.data[i]
      }
      this.setState({
        images: images,
        files: documents
      }, () => {
        // console.log('images in state ', this.state)
      })
    })
    // }, () => {

    // })
  }

  onDropRejected (files) {
    let newErrors = []
    files.map((val, index) => {
      newErrors.push('File: ' + val.name + ' is not allowed.')
    })
    this.setState({ upload: { ...this.state.upload, errors: newErrors } })
  }

  deleteImage (image, index) {
    this.setState({
      confirm: index
    })
  }
  renderFiles () {
    let files = this.state.files
    const removeFile = (index) => {
      let oldFiles = this.state.files
      // console.log('Remove file at index ', index)
      let newFiles = [...oldFiles].filter((item, i) => {
        // console.log('filter: ', i, '(' + index + ' = ' + i + ')')
        return i !== index
      })

      this.setState({
        files: newFiles
      })
    }
    const renderFile = (file, index) => {
      if (file.file === null) return null
      let thumbUrl = API_URL + '/FileService/GetIcon?fileName=' + file.name

      // let newFileUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ActualFileName + '&token=' + this.props.auth.user.Token
      // let thumbUrl = API_URL + '/FileService/DownloadNoHeader?fileName=' + file.ThumbURL + '&token=' + this.props.auth.user.Token
      return (
        <div key={index} className='file-document clearfix'>
          <img className='file-icon' alt='icon' src={thumbUrl} />
          <span>{file.name}</span>
          {this.props.auth.user.CustomerId === '-1' && <img className='file-delete' src='/images/icons/Delete_16.png' onClick={() => removeFile(index)} />}
        </div>
      )
    }

    return (
      <div className='estimation_documents'>
        {files.map(renderFile)}
      </div>
    )
  }
  renderRejectedImages (rejectedImages) {
    const renderRejectedImage = (image, index) => {
      let url = API_BASE + image.ThumbURL
      let fullUrl = API_BASE + image.FileURL
      return (
        <div key={index} className='file-image'>
          <a href={fullUrl} data-lightbox='gallery' data-title={image.FileName}><img src={url} /></a>
        </div>
      )
    }
    // Return
    return (
      <div className='estimation_images'>
        <Gallery files={rejectedImages} renderImage={renderRejectedImage} />
      </div>
    )
  }

  renderImages () {
    const imageCheckChange = (e) => {
      this.setState({ selectedImages: { ...this.state.selectedImages, [e.target.id]: e.target.checked } })
    }
    let { images } = this.state
    // Render image
    const renderImage = (image, index) => {
      if (image.imageUrl !== undefined) {
        return (
          <div key={index}>
            <div className='divImg'>
              <div className='delete'><RemoveButton {...this.props} onClick={() => this.deleteImage(image, index)} size='s' /></div>
              <img className='img2' src={image.imageUrl} onClick={() => { /* this.goToImage(image, index)} */ }} />
            </div>
            <div className='divCheckbox'>
              <Check spacing={0} labelText={this.t('1218')} checked='true' contentEditable='false' name='checkbox_image' />
            </div>
          </div>
        )
      } else {
        return (
          <div key={index}>
            <div className='divImg'>
              <a href={image.imagePath} data-lightbox='gallery'>
                <img className='img3' id={image.OrderFileID} name='oldImages' src={image.thumbPath} />
              </a>
            </div>
            <div className='divCheckbox'>
              <Check spacing={0} labelText={this.t('1218')} id={image.OrderFileID} name='checkbox_image' onChange={imageCheckChange} checked={this.state.selectedImages[image.OrderFileID] === true} />
            </div>
          </div>
        )
      }
    }
    // Confirm
    const onPortalClose = () => {
      this.setState({
        confirm: false
      })
    }
    const onConfirm = () => {
      let images = [...this.state.images]
      images.splice(this.state.confirm, 1)
      this.setState({
        confirm: false,
        images: images
      })
    }
    // Return
    return (
      <div className='estimation_images'>
        <Gallery files={images} renderImage={renderImage} />
        {this.state.confirm !== false && (
          <Portal className='deleteModal' onPortalClose={onPortalClose}>
            <Confirm confirm={onConfirm} notConfirm={onPortalClose} />
          </Portal>
        )}
      </div>
    )
  }

  goToImage (image, index) {
    this.setState({
      tabView: 'step2',
      activeImage: {
        image: image,
        index: index
      }
    })
  }

  submitImage (image) {
    let images = [...this.state.images]
    images[image.index] = image.image
    this.setState({
      tabView: 'step1',
      images: images
    })
  }

  renderStep2 () {
    const circleDrag = (active) => {
      this.setState({ overflowHidden: false })
    }
    return (
      <CircleImage submitImage={this.submitImage} image={this.state.activeImage} onDrag={circleDrag} />
    )
  }

  onClose () {
    if (this.state.tabView === 'step2') {
      this.setState({
        tabView: 'step1'
      })
    } else {
      this.props.onClose()
    }
  }

  render () {
    let tabView = <div />
    let headerTitle = translation('13363')
    let bottomBarProps = null

    if (this.state.tabView === 'step1') {
      tabView = this.renderStep1()
      bottomBarProps = {
        disabled: this.state.isLoading,
        actionLabelText: translation('27'),
        onActionClick: this.createEstimation
      }
    } else if (this.state.tabView === 'step2') {
      tabView = this.renderStep2()
    }

    let clickOutsideClose = false
    return (
      <div className='createestimation__modal'>
        <Modal
          {...this.props}
          header={headerTitle}
          overflowHidden={this.state.overflowHidden}
          clickOutsideClose={clickOutsideClose}
          onClose={this.onClose}
          icon={ModalIcons.Estimation}
          bottomBarProps={bottomBarProps}
        >
          {tabView}
        </Modal>
      </div>
    )
  }
}

CreateEstimationModal.propTypes = {
  createOrderEstimation: PropTypes.func.isRequired,
  uploadMultipleFiles: PropTypes.func.isRequired,
  hasSubscriptionPermission: PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  createOrderEstimation,
  uploadMultipleFiles,
  uploadImageMarkings,
  hasSubscriptionPermission,
  getRejectedEvaluations,
  getOrderFiles,
  DeleteExifData
})(CreateEstimationModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/CreateEstimationModal/index.js